import styled from "styled-components";
import ThemeColors from "../../../../../themes/colors";

export const MainContainer = styled.div<{ selected: boolean }>`
  display: flex;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
  border-radius: 1rem;
  padding: 0.75rem;
  background-color: ${(props) =>
    props.selected ? ThemeColors.Gray500 : ThemeColors.Bg300};
`;
